import { render, staticRenderFns } from "./HomeForOtherOfficeService.vue?vue&type=template&id=500ff17b&scoped=true&lang=pug"
import script from "./HomeForOtherOfficeService.vue?vue&type=script&lang=ts"
export * from "./HomeForOtherOfficeService.vue?vue&type=script&lang=ts"
import style0 from "./HomeForOtherOfficeService.vue?vue&type=style&index=0&id=500ff17b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500ff17b",
  null
  
)

export default component.exports